import { graphql } from "../generated/gql";

// Creates the query for the query sessions type
graphql(/* GraphQL */ `
query GetBopForTrackerTable($sessionIds: [MongoID!]!) {
  sessions(filter: { _operators: { _id: { in: $sessionIds } } }, sort: TSESSIONSTART_ASC, perPage: 1000) {
    items {
      _id
      name
      shortName
      tSessionStart
      bop {
        _id
        name
        sessionID
        session {
          _id
          name
          shortName
        }
        carBop {
          highlightColour
          aCamberFmax
          aCamberFmin
          aCamberRmax
          aCamberRmin
          aRakeMax
          aRakeMin
          aWingRmax
          aWingRmin
          zWingMin
          carSpec
          homologation
          hRideFmin
          hRideRmin
          make
          mCarBallastMin
          mCarWeightEmptyMin
          mCarWeightTotalMin
          mFuelMassCapacityMax
          modelYear
          mRefuelMassMax
          nEngineMax
          pEngineBoost
          PEngineMax
          rLambdaMin
          vCarMax
          VFuelVolumeCapacityMax
          vPowerCurveBelowRefVelocity
          rPowerCurveReference
          rPowerGainAboveRefVelocity
          vPowerGainReference
          VRefuelVolumeMax
          xAirRestrictorMax
          xFuelRestrictorMax
          xRefuelRestrictorMax
          EStintMax
          _id
        }
        sessionBop {
          EStintEnergyMax
          EStintEnergyRefillRateMax
          fuelType
          mRefuelRateMax
          pAmbientSessionOfficial
          tyreModel
          VRefuelRateMax
          xStintlengthMax
          _id
        }
      }
    }
  }
}
`);
